import { zodResolver } from '@hookform/resolvers/zod';
import { TextField } from '@nest/internal-frontend';
import { Button, Form, useScanner, useValidationResultDialog } from '@nest/uikit-react';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { z } from 'zod';
import { useTerminalClient } from '../client-rpc-router';
import { TerminalScreen } from '../components/TerminalScreen';

export default function InfoPage() {
	const navigate = useNavigate();
	const client = useTerminalClient();
	const scanner = useScanner();
	const [searchCode, setSearchCode] = useState<string | null>(null);

	const schema = z.object({
		code: z.string().min(1)
	});

	const form = useForm({
		resolver: zodResolver(schema),
		defaultValues: { code: '' }
	});

	const searchQuery = useQuery({
		queryKey: ['wmsCodeInfo', searchCode],
		queryFn: () => client.wms.getWmsCodeInfoQuery.execute({ code: searchCode! }),
		enabled: searchCode !== null
	});

	useEffect(() => {
		if (searchQuery.data) {
			const result = searchQuery.data as {
				location?: { id: number; code?: string } | null;
				handlingUnits?: Array<{ id: number; code?: string }>;
				stockItems?: Array<{ id: number }>;
			};

			if (result.location) {
				const codeParam = result.location.code ? `?code=${encodeURIComponent(result.location.code)}` : '';
				navigate(`/storage/locations/${result.location.id}${codeParam}`);
			} else if (result.handlingUnits?.length && result.handlingUnits[0]) {
				const hu = result.handlingUnits[0];
				const codeParam = hu.code ? `?code=${encodeURIComponent(hu.code)}` : '';
				navigate(`/handling-units/${hu.id}${codeParam}`);
			} else if (result.stockItems?.length && result.stockItems[0]) {
				navigate(`/stock-items/${result.stockItems[0].id}`);
			}
		}
	}, [searchQuery.data, navigate]);

	useValidationResultDialog([searchQuery.error]);

	useEffect(() => {
		if (scanner.code) {
			form.setValue('code', scanner.code, { shouldDirty: true, shouldTouch: true });
			doSearch(scanner.code);
		}
	}, [scanner.code]);

	const doSearch = async (searchCodeParam?: string) => {
		const codeToSearch = searchCodeParam ?? form.getValues('code');

		if (!codeToSearch) {
			return;
		}

		setSearchCode(codeToSearch);
	};

	const handleSubmit = form.handleSubmit(values => {
		doSearch(values.code);
	});

	return (
		<TerminalScreen topBar={<div>Info</div>} showBackButton>
			<Form {...form}>
				<div className="p-4">
					<div className="mb-4">
						<TextField control={form.control} name={'code'} label="Zadejte anebo naskenujte kód" autoFocus onEnter={handleSubmit} />
					</div>
					<div className="main-button-container">
						<Button type="button" variant="default" className="mt-4 w-full" loading={searchQuery.isFetching} onClick={handleSubmit}>
							Vyhledat
						</Button>
					</div>
				</div>
			</Form>
		</TerminalScreen>
	);
}
